// extracted by mini-css-extract-plugin
module.exports = {"labels":"_93444fe79c--labels--L8WyJ"};